/** @jsx jsx */
import PropTypes from 'prop-types'
import { jsx } from '@emotion/core'
import uuid from 'uuid/v4'
import { Component } from 'react'

import { colors } from '../../../../constants'

const propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
}

const defaultProps = {
	alt: '',
}

class WithChrome extends Component {
	constructor(props) {
		super(props)
		this.patternID = uuid()
	}

	render() {
		const { src } = this.props

		return (
			<div
				data-comp="mobile-screen-with-chrome"
				css={{
					position: 'relative',
					flex: 1,
				}}
			>
				<div
					css={{
						zIndex: 0,
						position: 'absolute',
						top: '25%',
						left: 0,
						width: '100%',
						height: '50%',
						backgroundColor: colors.white,
						transition: 'all 175ms linear 1ms',
					}}
				/>

				<div
					css={{
						zIndex: 0,
						position: 'absolute',
						top: 0,
						right: 0,
						width: '100%',
						background: colors.white,
						borderRadius: '12% 12% 0 0',
						transition: 'all 175ms linear 1ms',
						'& img': {
							display: 'block',
							width: '100%',
						},
					}}
				>
					{/* http://png-pixel.com 1x1 */}
					<img
						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
						alt=""
					/>
				</div>

				<div
					css={{
						zIndex: 0,
						position: 'absolute',
						bottom: 0,
						right: 0,
						width: '100%',
						background: colors.white,
						borderRadius: '0 0 12% 12% ',
						transition: 'all 175ms linear 1ms',
						'& img': {
							display: 'block',
							width: '100%',
						},
					}}
				>
					<img
						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
						alt=""
					/>
				</div>

				<svg
					width="100%"
					height="100%"
					viewBox="0 0 423 861"
					css={{
						position: 'relative',
						zIndex: 100,
						display: 'block',
						maxWidth: '100%',
					}}
				>
					<defs>
						<pattern
							id={this.patternID}
							patternUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="375"
							height="667"
						>
							<image href={src} x="0" y="0" width="375" height="667" />
						</pattern>
					</defs>
					<g
						transform="translate(24.000000, 97.000000)"
						stroke={colors.ink}
						vectorEffect="non-scaling-stroke"
						strokeWidth="0"
					>
						<rect
							x="0"
							y="0"
							width="375"
							height="667"
							stroke={colors.taupe}
							strokeWidth="1"
							fill={`url(#${this.patternID})`}
							rx="4"
						/>
					</g>
				</svg>
			</div>
		)
	}
}

WithChrome.propTypes = propTypes
WithChrome.defaultProps = defaultProps

export default WithChrome
